import {Col, FormGroup, Input, Label, Row} from "reactstrap";
import {I18n} from "../../../I18n/components/promoter";
import React from "react";

const PromoterVideoSelectRow = props => {
    return (
        <Row>
            <Col xs="12" md="12" lg="12">
                <FormGroup>
                    <Label for="video">
                        {I18n[props.lang].video}
                    </Label>
                    <div className="custom-file">
                        <Input
                            className="custom-file-input"
                            type="file"
                            id="file"
                            name="file"
                            accept="video/*"
                            onChange={props.onVideoChange}
                            required
                        />
                        <label className="custom-file-label" htmlFor="file">
                            {props.fileName}
                        </label>
                    </div>
                    {props.validator.showErrors('file')}
                </FormGroup>
            </Col>
        </Row>
    )
}

export default PromoterVideoSelectRow;


// WEBPACK FOOTER //
// ./src/components/Promoter/PromoterVideo/PromoterVideoSelectRow.js